/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetClipIsBulkBillingCompanyResponseData,
    GetClipIsBulkBillingCompanyResponseDataFromJSON,
    GetClipIsBulkBillingCompanyResponseDataFromJSONTyped,
    GetClipIsBulkBillingCompanyResponseDataToJSON,
} from './GetClipIsBulkBillingCompanyResponseData';

/**
 * 
 * @export
 * @interface GetClipIsBulkBillingCompanyResponse
 */
export interface GetClipIsBulkBillingCompanyResponse {
    /**
     * HTTPステータスコード
     * @type {number}
     * @memberof GetClipIsBulkBillingCompanyResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetClipIsBulkBillingCompanyResponse
     */
    message: string;
    /**
     * 
     * @type {GetClipIsBulkBillingCompanyResponseData}
     * @memberof GetClipIsBulkBillingCompanyResponse
     */
    data: GetClipIsBulkBillingCompanyResponseData;
}

export function GetClipIsBulkBillingCompanyResponseFromJSON(json: any): GetClipIsBulkBillingCompanyResponse {
    return GetClipIsBulkBillingCompanyResponseFromJSONTyped(json, false);
}

export function GetClipIsBulkBillingCompanyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClipIsBulkBillingCompanyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': GetClipIsBulkBillingCompanyResponseDataFromJSON(json['data']),
    };
}

export function GetClipIsBulkBillingCompanyResponseToJSON(value?: GetClipIsBulkBillingCompanyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': GetClipIsBulkBillingCompanyResponseDataToJSON(value.data),
    };
}

